import { Body, Box, Heading } from '@hover/blueprint';
import { StaticImage } from 'gatsby-plugin-image';
import React from 'react';
import QuotationMarkIconNavy from '../../../assets/svgs/QuotationMarkIconNavy';

const Quote: React.FC = () => (
  <Box alignItems="flex-start">
    <Box
      w={300}
      minW={300}
      alignItems="center"
      justifyContent="center"
      mr={300}
    >
      <QuotationMarkIconNavy />
    </Box>
    <Box flexDir="column" alignItems="flex-start">
      <Heading
        size={{ base: 300, tablet: 500 }}
        isDisplay
        marginBottom={{ base: 500, desktop: 500 }}
        as="p"
      >
        Now I bid on jobs I didn’t have the time to scale off from a blueprint
        before.
        <br /> <br />I send job plans through HOVER for a fast bid and I include
        the 3D model with our proposals… which helps me stand out from everyone
        else who is bidding that job.”
      </Heading>
      <Body size={300} isBold textTransform="uppercase" letterSpacing="0.1rem">
        David Ferraro
      </Body>
      <Body
        mb={400}
        size={300}
        textTransform="uppercase"
        letterSpacing="0.1rem"
      >
        Owner, Good Guys Contracting
        <br /> Long Island, NY
      </Body>
      <Box maxW="80px">
        <StaticImage
          src="../../../assets/images/good_guys_logo.png"
          alt="ood Guys Contracting"
          objectFit="contain"
          placeholder="blurred"
        />
      </Box>
    </Box>
  </Box>
);

export default Quote;
